import constants from "./constants";
import router from '@/router'
import { SWITCH_ROLE} from '../store/actions.type';

export default function switchRole(role) {
  if(role !== localStorage.getItem(constants.CURRENT_ROLE)){
    this.$store.dispatch(SWITCH_ROLE,role);
      router.push('/dashboard');
      location.reload();
  }
};
